import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableElfProdMode } from '@ngneat/elf';
import { devTools } from '@ngneat/elf-devtools';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initDayJs } from './day-js';

initDayJs();

if (environment.production) {
  // initSentry();
  enableProdMode();
  enableElfProdMode()
} else {
  devTools();

  // In dev mode, unregister any stale service workers (e.g. from a previous prod build
  // served at the same origin). A registered ngsw that can't find ngsw.json will keep
  // triggering reload loops in ng serve.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const reg of registrations) {
        reg.unregister().then(ok => {
          if (ok) console.warn('[dev] Unregistered stale service worker — refresh the page once.');
        });
      }
    });
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
